export default __webpack_public_path__ + "static/media/Poppy_Arch_Mark_Linen.954c9277.svg";